<template>
  <div class="tags-wrapper">
    <Tags
      :onChange="onTagsChange"
      :settings="tagifySettings"
      :initial-value="initial"
    ></Tags>
  </div>
</template>

<script>
import Tags from "@yaireo/tagify/dist/tagify.vue";
import apiClientCreator from "@/helpers/api/request";

export default {
  props: {
    path: {
      type: String
    },
    initial: {
      type: Array
    },
    editMode: {
      type: Boolean
    }
  },
  name: "FinanceTags",
  components: { Tags },
  data() {
    return {
      initData: [],
      tagifySettings: {
        placeholder: this.path,
        whitelist: [],
        callbacks: {
          add(e) {},
          focus: e => {},
          remove: e => {}
        }
      },
      suggestions: []
    };
  },
  mounted() {
    this.getPurchaseTypes();
  },
  methods: {
    getPurchaseTypes() {
      let url;
      if (this.path === "types") {
        url = "finance/get_types";
      }

      if (this.path === "reasons") {
        url = "finance/get_reasons";
      }
      if (this.path === "projects") {
        url = "finance/get_projects";
      }
      if (this.path === "details") {
        url = "finance/get_details";
      }
      apiClientCreator(`${url}`)
        .get("")
        .then(result => {
          result.data.forEach(r => {
            if (this.path === "types") {
              this.tagifySettings.whitelist.push(r.type);
            }
            if (this.path === "reasons") {
              this.tagifySettings.whitelist.push(r.reason);
            }
            if (this.path === "projects") {
              this.tagifySettings.whitelist.push(r.project);
            }
            if (this.path === "details") {
              this.tagifySettings.whitelist.push(r.detail);
            }
          });
        });
    },

    onTagsChange(tags) {
      if (!this.editMode) {
        if (tags.target.value.length !== 0) {
          this.$emit("tagsAdded", [JSON.parse(tags.target.value), this.path]);
        }
        if (tags.target.value.length === 0) {
          this.$emit("tagsAdded", [[], this.path]);
        }
      }
      if (this.editMode) {
        if (tags.target.value.length !== 0) {
          this.$emit("tagsEdit", [JSON.parse(tags.target.value), this.path]);
        }
        if (tags.target.value.length === 0) {
          this.$emit("tagsEdit", [[], this.path]);
        }
      }
    }
  }
};
</script>

<style scoped>
.tags-wrapper {
  overflow-y: scroll;
  height: 35px;
  border-bottom: 1px solid black;
  padding-bottom: 1px;
}
.tags-wrapper::-webkit-scrollbar {
  display: none;
}
</style>
